







































import { defineComponent, ref, PropType } from '@vue/composition-api';
import { NavigationGuard } from 'vue-router';
import sl from '@/serviceLocator';
import defaultRouter from '../../../router';
import Router from 'vue-router';

const beforeRouteEnter: NavigationGuard = (to, from, next) => {
  next(() => {
    const store = sl.get('store');
    if (store.getters.isAuthenticated) {
      defaultRouter.push('/');
    }
  });
};

export default defineComponent({
  name: 'LoginView',
  props: {
    router: {
      type: Object as PropType<Router>,
      default: () => defaultRouter,
    },
  },
  beforeRouteEnter,
  setup({ router }) {
    const store = sl.get('store');
    const server = sl.get('serverProxy');

    const email = ref('');
    const password = ref('');
    const errorMsg = ref('');
    const loadings = ref({ signInButton: false });

    const logIn = async () => {
      loadings.value.signInButton = true;
      errorMsg.value = '';
      let userData = {
        email: email.value,
        password: password.value,
      };

      try {
        await server.login(userData);
        const permissions = await server.getUserPermissions();
        store.setPermissions(permissions);
        router.push('/');
      } catch (err) {
        const errorCode = (err as any).code;
        if (
          errorCode === 'auth/wrong-password' ||
          errorCode === 'auth/user-not-found'
        ) {
          errorMsg.value = 'Invalid credentials';
        } else if ((err as any).message) {
          errorMsg.value = (err as any).message;
        } else {
          errorMsg.value = 'There was an unknown error';
        }
      } finally {
        loadings.value.signInButton = false;
      }
    };

    return {
      email,
      password,
      errorMsg,
      loadings,
      logIn,
    };
  },
});
